<template>
    <div :class="['subject-areas-menu', theme]">
        <span :class="['subject-areas-menu__label', $totemLang]" @click="toggleSubjectAreasMenu()">
            <span class="subject-areas-menu__icon icon-books"></span>
            <span class="subject-areas-menu__truncated-label" v-html="selectedSubjectArea"></span>
            <span class="icon-cancel" v-if="isSelectedMainPackage" @click="goToAllSubjectAreas"></span>
            <span :class="['icon-chevron-down', getClassForDropDownIcon]"></span>
        </span>
        <ul :class="['subject-areas-menu__list', {'show': isSubjectAreasMenuOpen}, columnLayout]">
            <li
                class="subject-areas-menu__item"
                v-for="subjectArea in subjectAreas"
                @click="goToSubjectArea(subjectArea)"
                :key="subjectArea.code"
                :data-text="stripHtml(subjectArea.label)"
                v-html="subjectArea.label"
            >
            </li>
            <li class="subject-areas-menu__item">
                <TotemButton @click="goToAllSubjectAreas" color="primary" :label="$t('StoreMenu.all_subject_areas')" />
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { viewTypes } from 'store/modules/search'
    import subjectAreaNavigationHelper from 'components/layout/mixins/subjectAreaNavigationHelper'

    export default {
        name: 'subject-areas-menu',
        mixins: [subjectAreaNavigationHelper],
        inject: ['headerTheme'],
        computed: {
            ...mapGetters({
                categories: 'Menu/getCategories',
                selectedMainPackage: 'Search/getSelectedMainPackage',
                viewType: 'Search/getViewType',
                isSubjectAreasMenuOpen: 'Menu/isSubjectAreasMenuOpen'
            }),
            subjectAreas () {
                return this.categories.map(el => ({
                    label: el.translatedName,
                    code: el.slug,
                    customerSpecific: el.customerSpecific
                }))
            },
            columnLayout () {
                if (this.subjectAreas.length > 8 && this.subjectAreas.length <= 16) {
                    return 'two-columns'
                } else if (this.subjectAreas.length > 16) {
                    return 'three-columns'
                }
                return ''
            },
            selectedSubjectArea () {
                if (this.isSelectedMainPackage && this.subjectAreas.length > 0) {
                    return this.subjectAreas.filter(el => el.code === this.selectedMainPackage)[0].label
                }
                return this.$t('StoreMenu.all_subject_areas')
            },
            isSelectedMainPackage () {
                const nullable = ['', null, undefined]
                return !nullable.includes(this.selectedMainPackage)
            },
            getClassForDropDownIcon () {
                return this.isSubjectAreasMenuOpen ? 'open' : 'close'
            },
            theme () {
                return this.headerTheme()
            }
        },
        methods: {
            toggleSubjectAreasMenu () {
                this.$store.dispatch('Menu/toggleSubjectAreasMenu')
            },
            closeMenu (e) {
                this.$store.dispatch('Menu/setSubjectAreasMenu', this.getAllowedElementsToCloseMenu(e))
            },
            getAllowedElementsToCloseMenu (e) {
                return (this.$el.contains(e.target) && !e.target.classList.contains('subject-areas-menu__list'))
            },
            stripHtml(html) {
                const tmp = document.createElement('DIV');
                tmp.innerHTML = html;
                return tmp.textContent || tmp.innerText || '';
            }
        },
        created () {
            window.addEventListener('click', this.closeMenu)
        },
        beforeDestroy () {
            window.removeEventListener('click', this.closeMenu)
        }
    }
</script>

<style lang="scss" scoped>
.subject-areas-menu {
    position: relative;
    width: 260px;

    &.light {
        .subject-areas-menu__label {
            border: 1px solid $lavender;
            background: $astral;
            color: $black;
            border-radius: 30px;
            background: $white;
        }
    }

    &.dark {
        .subject-areas-menu__label {
            border: 1px solid $lavender;
            background: $astral;
            color: $black;
            border-radius: 30px;
            background: $white;

            &:hover {
                background: $light_blue;
            }
        }
    }

    &__label {
        border-radius: 5px;
        display: flex;
        height: 42px;
        padding: 0 20px;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        white-space: nowrap;
    }

    &__truncated-label {
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 2rem;
    }

    &__icon {
        color: $lavender;
    }

    &__list {
        top: 59px;
        position: absolute;
        border: solid $alto 1px;
        background: $white;
        padding: 15px;
        gap: 50px;
        opacity: 0;
        visibility: hidden;
        transition: visibility 0s linear 300ms, opacity 300ms;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.20);

        &.show {
            visibility: visible;
            opacity: 1;
            transition: visibility 0s linear 0s, opacity 300ms;
        }

        &.two-columns {
            column-count: 2;
        }

        &.three-columns {
            column-count: 2;

            [class*="desktop_xxxl"] & {
                column-count: 3;
            }
        }
    }

    &__item {
        white-space: nowrap;
        padding: 10px;
        cursor: pointer;
        color: $carbon;
        position: relative;

        &:hover {
            color: transparent;
        }

        &:hover:after {
            color: $black;
            font-weight: 600;
        }

        &:after {
            content: attr(data-text);
            position: absolute;
            left: 10px;
        }
    }

    .icon-chevron-down {
        position: absolute;
        right: 15px;

        &.open {
            transition: transform 0.3s ease;
            transform: rotate(-180deg);
        }
        &.close {
            transform: rotate(0deg);
            transition: transform 0.3s linear;
        }
    }

    .icon-cancel {
        position: absolute;
        right: 35px;
        color: $lavender;
    }
}
</style>
